import React from 'react'
import { AutocompleteCreatable, autocompleteHelpers } from 'elentari'
import referenciaTransportadoraRepository from './referenciaTransportadoraRepository'
import { useField } from 'react-final-form'
const { toOption } = autocompleteHelpers

export const loadCategoria = async inputValue => {
  const response = await referenciaTransportadoraRepository.list({
    query: {
      nome: inputValue,
      order: 'nome asc'
    },
    paginate: {
      limit: 10
    }
  })
  if (response.ok) {
    return response.data.map(toOption('nome', ['telefone', 'id']))
  }
  return []
}

const RFFReferenciaTransportadoraAutocomplete = ({
  showError,
  labelOption = 'nome',
  ...props
}) => {
  const { meta, ...field } = useField(props.name, props)
  const metaShowError = {
    ...meta,
    touched: meta.touched || showError
  }

  return (
    <AutocompleteCreatable
      {...props}
      {...field}
      repository={referenciaTransportadoraRepository}
      labelOption={labelOption}
      loadOptions={inputValue => loadCategoria(inputValue)}
      meta={metaShowError}
      input={{
        ...field.input,
        onChange: value => {
          props.onChange(value)
          field.input.onChange(value)
        }
      }}
      textFieldProps={{
        shrink: true
      }}
      fullWidth
    />
  )
}

export default RFFReferenciaTransportadoraAutocomplete
